export const APP_STORE_URL = 'https://apps.apple.com/us/app/civilgrid/id1643631782';
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.civilgrid.app';
